var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { classNames } from '@web/utility';
import { createPortal } from 'react-dom';
import { Tooltip } from 'react-tooltip';
var INFO_POPUP_TOOLTIP_STYLE = {
    maxWidth: '350px',
    wordWrap: 'break-word',
    lineHeight: '1.4',
    whiteSpace: 'pre-line'
};
var InfoPopUp = function (_a) {
    var text = _a.text, children = _a.children, classes = _a.classes, tooltipClasses = _a.tooltipClasses, _b = _a.id, id = _b === void 0 ? 'infoPopUp' : _b, _c = _a.containerClasses, containerClasses = _c === void 0 ? '' : _c, _d = _a.place, place = _d === void 0 ? 'right' : _d, _e = _a.noMargin, noMargin = _e === void 0 ? false : _e, _f = _a.flexTrigger, flexTrigger = _f === void 0 ? false : _f;
    return (_jsxs("div", __assign({ className: classNames(containerClasses, flexTrigger
            ? 'inline-flex items-center relative'
            : 'flex flex-col items-center relative') }, { children: [_jsx("div", __assign({ "data-tooltip-id": id, "data-tooltip-content": text, className: classNames(classes, 'text-gray-500 flex-shrink-0', flexTrigger
                    ? 'inline-flex cursor-pointer items-center gap-0.5'
                    : 'w-5 h-5', !noMargin && 'sm:mr-2') }, { children: children })), typeof document !== 'undefined'
                ? createPortal(_jsx(Tooltip, { id: id, className: tooltipClasses, place: place, offset: 8, opacity: 1, positionStrategy: "fixed", variant: "dark", style: INFO_POPUP_TOOLTIP_STYLE }), document.body)
                : null] })));
};
export default InfoPopUp;
